// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'bill-of-material.page.title': 'Bill of Materials',
    'bill-of-material.page.search_results': 'Search Results',
    'bill-of-material.page.create.title': 'New Bill of Material',
    'bill-of-material.page.search.title': 'Find Bill of Materials',
    'bill-of-material.page.edit.title': 'Edit Bill of Material',
    'bill-of-material.page.all': 'All',

    'bill-of-material.button.cancel': 'Cancel',
    'bill-of-material.button.select': 'Select',
    'bill-of-material.button.find': 'Find Bill of Materials',
    'bill-of-material.button.search': 'Apply',
    'bill-of-material.button.create': 'Create Bill of Material',
    'bill-of-material.button.new': 'New Bill of Material',
    'bill-of-material.button.save': 'Save Changes',
    'bill-of-material.button.archive': 'Archive',
    'bill-of-material.button.edit': 'Edit',
    'bill-of-material.button.reset': 'Reset',
    'bill-of-material.button.add_item': 'Add Component',
    'bill-of-material.button.remove_item': 'Remove',

    'bill-of-material.placeholder.search': 'Search Bill of Materials',

    'bill-of-material.link.create_first_bill_of_material': 'Click here to create your first bill of material',
    'bill-of-material.link.bill_of_materials': ' Return to Bill of Materials',
    'bill-of-material.link.retry': 'Click here to retry',

    'bill-of-material.checkbox.all': 'Check All',
    'bill-of-material.checkbox.actions_label': 'with selected',

    'bill-of-material.label.bom_name': 'BOM Name',
    'bill-of-material.label.bom_number': 'BOM Number',
    'bill-of-material.label.output_inventory_id': 'Output Product',
    'bill-of-material.label.output_quantity': 'Output Quantity',
    'bill-of-material.label.notes': 'Notes',
    'bill-of-material.label.effective_date': 'Effective Date',
    'bill-of-material.label.currency_id': 'Currency',
    'bill-of-material.label.revision': 'Revision',
    'bill-of-material.label.status': 'Status',
    'bill-of-material.label.currency_estimated_cost': 'Estimated Cost',
    'bill-of-material.label.component': 'Component',
    'bill-of-material.label.quantity_required': 'Qty Required',
    'bill-of-material.label.currency_unit_cost': 'Unit Cost',
    'bill-of-material.label.unit_of_measure': 'UOM',
    'bill-of-material.label.scrap_percentage': 'Scrap %',
    'bill-of-material.label.line_cost': 'Line Cost',
    'bill-of-material.label.total_estimated_cost': 'Total Estimated Cost',
    'bill-of-material.label.sub_total': 'Sub Total',
    'bill-of-material.label.components': 'Components',

    'bill-of-material.sort.field_label': 'Field',
    'bill-of-material.sort.direction_label': 'Direction',
    'bill-of-material.sort.direction_ascending': 'Ascending',
    'bill-of-material.sort.direction_descending': 'Descending',

    'bill-of-material.modal.title.bill_of_material_archive': 'Archive Bill of Material',
    'bill-of-material.modal.message.bill_of_material_archive': 'Are you sure that you want to move this bill of material to the archive? | Are you sure that you want to move these bills of material to the archive?',

    'bill-of-material.success.message.bill_of_material_created': 'Your bill of material has been created',
    'bill-of-material.success.message.bill_of_material_updated': 'Your bill of material has been updated',
    'bill-of-material.success.message.archived_bill_of_materials': 'Your bill of material was moved to the archive | All selected bills of material were moved to the archive',

    'bill-of-material.error.message.archived_bill_of_materials': 'This bill of material was already moved to the archive | These bills of material were already moved to the archive',
    'bill-of-material.error.message.error_loading_page': 'Sorry, there was an error loading bill of material.| Sorry, there was an error loading bills of material.',
};
